export const FACEBOOK_LINK = "https://www.facebook.com/AdjusttotheGoodLifeTravel/";
export const INSTAGRAM_LINK = "https://www.instagram.com/adjusttothegoodlifetravel/";
